<template>
  <div class="fill-height" style="display: flex; align-items: end">
    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ props }">
        <div v-bind="props" class="container">
          <span :style="{ fontSize: `${fontSize}px` }">
            {{ inputVal }}
          </span>
          <ColorIndicator :color="inputVal" class="mb-1" />
        </div>
      </template>
      <v-card>
        <v-card-text>
          <v-color-picker elevation="0" v-model="inputVal" mode="hexa" />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ColorIndicator from '@/components/common/ColorIndicator.vue'

export default {
  name: 'ColorSelector',
  components: { ColorIndicator },
  props: {
    modelValue: {
      type: String,
      required: true
    },
    fontSize: {
      type: Number,
      default: 14
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:model-value', val)
      }
    }
  },
  emits: ['input']
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
}
</style>
